const TARJETAS_HARDCODED_YPF = [
  {
    idTarjetaCredito: 0,
    nombre: "AGRO CABAL",
    idTarjeta: 1,
    codigoComercio: "",
    pagoElectronicoNombre: null,
    pagoElectronico: false,
    usadaEnVentas: false,
    codigoTarjeta: null,
    codigoLapos: null,
    posicionGrilla: 0,
    tipoUtilizacion: null,
    extraCash: false,
  },
];

const getTarjetas = async () => {
  return TARJETAS_HARDCODED_YPF;
};

const tarjetas = {
  getTarjetas,
};

export default tarjetas;
